export { default as ProductsIndexPageBreadcrumbsItem } from './ProductsIndexPageBreadcrumbsItem';
